<template>
  <el-tag class="tag" :size="size" :type="type" @click="handleTagClicked">
    {{ tagName }}
  </el-tag>
</template>

<script>
export default {
  name: "QueryTag",
  props: ["tagName", "size", "type"],
  methods: {
    handleTagClicked() {
      this.$router.push({
        path: this.$route.path,
        query: { tag: this.tagName, page: "1" }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.tag {
  cursor: pointer;
}
</style>
